import LocaleHelper from '../LocaleHelper.js'

// Language-specific loader for separate translation files
// Generated translation files are loaded on demand

// Cache for loaded language data
const languageCache = new Map();
const loadingPromises = new Map();

// Load language data from separate JSON files
const loadLanguageData = async (language) => {
    // Check cache first - if we already have it, return immediately
    if (languageCache.has(language)) {
        return languageCache.get(language);
    }
    
    // Check if we're already loading this language - if so, wait for that promise
    if (loadingPromises.has(language)) {
        return loadingPromises.get(language);
    }
    
    const loadingPromise = (async () => {
        try {
            // Try loading the language-specific file first
            const languageModule = await import(
                /* webpackChunkName: "translations-[request]" */
                `./translations.${language}.json`
            );
            
            if (languageModule.default) {
                // Cache the result
                languageCache.set(language, languageModule.default);
                loadingPromises.delete(language);
                
                return languageModule.default;
            } else {
                throw new Error(`No default export found in translations.${language}.json`);
            }
        } catch (separateFileError) {
            // Fallback: Try loading from the main translations.json file
            try {
                const mainModule = await import(
                    /* webpackChunkName: "translations-fallback" */
                    './translations.json'
                );
                
                // Only extract the requested language - don't load the whole file
                if (mainModule.default[language]) {
                    const languageData = {
                        [language]: mainModule.default[language],
                        _refs: mainModule.default._refs
                    };
                    
                    // Cache the result
                    languageCache.set(language, languageData);
                    loadingPromises.delete(language);
                    
                    return languageData;
                } else {
                    throw new Error(`Language ${language} not found in main translations.json`);
                }
                
            } catch (fallbackError) {
                loadingPromises.delete(language);
                
                return null; // FINAL FAILURE
            }
        }
    })();
    
    loadingPromises.set(language, loadingPromise);
    return loadingPromise;
};

const isLanguageCached = (language) => {
    return languageCache.has(language);
};

export {
    loadLanguageData,
    isLanguageCached
}; 